<template>
  <div id="stent-gebruiker-toevoegen">
    <div v-if="!done">
      <h1>Meld je aan</h1>

      <form v-on:submit.prevent="submit">
        <div class="row g-4 gy-md-5 gx-md-6 mb-6">
          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{ 'error': form.errors.voornaam.length > 0 }">
              <label>Voornaam <span class="requirement">(verplicht)</span></label>
              <input type="text" class="form-control" v-model="form.data.voornaam" _required>

              <ul v-if="form.errors.voornaam.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.voornaam" :key="error" class="sgt-field-error">{{ error }}</li>
              </ul>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container">
              <label>Tussenvoegsel</label>
              <input type="text" class="form-control" v-model="form.data.voorvoegsels">

              <ul v-if="form.errors.voorvoegsels.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.voorvoegsels" :key="error" class="sgt-field-error">{{ error }}</li>
              </ul>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{ 'error': form.errors.achternaam.length > 0 }">
              <label>Achternaam <span class="requirement">(verplicht)</span></label>
              <input type="text" class="form-control" v-model="form.data.achternaam" _required>

              <ul v-if="form.errors.achternaam.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.achternaam" :key="error" class="sgt-field-error">{{ error }}</li>
              </ul>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{'error': form.errors.geboortedatum.length > 0}">
              <label>Geboortedatum <span class="requirement">(verplicht)</span></label>
              <input type="text" v-model="form.data.geboortedatum" class="sgt-field-input form-control" placeholder="Formaat: dd-mm-yyyy" _required>

              <ul v-if="form.errors.geboortedatum.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.geboortedatum" :key="error" class="sgt-field-error">{{ error }}</li>
              </ul>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container email-container" :class="{ 'error': form.errors.email.length > 0 }">
              <label>E-mailadres <span class="requirement">(verplicht)</span></label>
              <input type="email" class="form-control" v-model="form.data.email" _required>

              <ul v-if="form.errors.email.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.email" :key="error" class="sgt-field-error">{{ error }}</li>
              </ul>
            </div>
          </div>

          <div class="col-sm-6 col-md-4">
            <div class="input-container" :class="{ 'error': form.errors.telefoonnummer.length > 0 }">
              <label>Telefoonnummer <span class="requirement">(verplicht)</span></label>
              <input type="text" v-model="form.data.telefoonnummer" class="sgt-field-input form-control" _required>

              <ul v-if="form.errors.telefoonnummer.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.telefoonnummer" :key="error" class="sgt-field-error">{{ error }}</li>
              </ul>
            </div>
          </div>

          <div class="col-sm-6 col-md-4" v-if="show_provincie_veld">
            <div class="input-container selectbox">
              <label>Provincie</label>

              <select v-model="form.data.provincie" data-lpignore="true" required="required" class="sgt-field-input form-select">
                <option value="" selected>Maak een keuze</option>
                <option value="Drenthe">Drenthe</option>
                <option value="Flevoland">Flevoland</option>
                <option value="Friesland">Friesland</option>
                <option value="Gelderland">Gelderland</option>
                <option value="Groningen">Groningen</option>
                <option value="Limburg">Limburg</option>
                <option value="Noord-Brabant">Noord-Brabant</option>
                <option value="Noord-Holland">Noord-Holland</option>
                <option value="Overijssel">Overijssel</option>
                <option value="Utrecht">Utrecht</option>
                <option value="Zeeland">Zeeland</option>
                <option value="Zuid-Holland">Zuid-Holland</option>
              </select>

              <ul v-if="form.errors.provincie.length > 0" class="stent-form-errors">
                <li v-for="error in form.errors.provincie" :key="error" class="sgt-field-error">{{ error }}</li>
              </ul>
            </div>
          </div>

          <div v-if="form.data.bijboekers.length > 0">
            <div v-for="(bijboeker, index) in form.data.bijboekers" :key="bijboeker" class="row g-4 gy-md-5 gx-md-6 mb-6">
              <div class="col-12">
                <div class="separator-title-container">
                  <h5>Bijboeker: {{ index + 1 }}</h5>
                </div>
              </div>

              <div class="col-sm-6 col-md-4">
                <div class="input-container" :class="{ 'error': form.errors[`bijboekers.${index}.voornaam`] !== undefined }">
                  <label>Voornaam <span class="requirement">(verplicht)</span></label>
                  <input type="text" class="form-control" v-model="form.data.bijboekers[index].voornaam" _required>

                  <ul v-if="form.errors[`bijboekers.${index}.voornaam`] !== undefined" class="stent-form-errors">
                    <li v-for="error in form.errors[`bijboekers.${index}.voornaam`]" :key="error" class="sgt-field-error">{{ error }}</li>
                  </ul>
                </div>
              </div>

              <div class="col-sm-6 col-md-4">
                <div class="input-container">
                  <label>Tussenvoegsel</label>
                  <input type="text" class="form-control" v-model="form.data.bijboekers[index].voorvoegsels">

                  <ul v-if="form.errors[`bijboekers.${index}.voorvoegsels`] !== undefined" class="stent-form-errors">
                    <li v-for="error in form.errors[`bijboekers.${index}.voorvoegsels`]" :key="error" class="sgt-field-error">{{ error }}</li>
                  </ul>
                </div>
              </div>

              <div class="col-sm-6 col-md-4">
                <div class="input-container" :class="{ 'error': form.errors[`bijboekers.${index}.achternaam`] !== undefined }">
                  <label>Achternaam</label>
                  <input type="text" class="form-control" v-model="form.data.bijboekers[index].achternaam" _required>

                  <ul v-if="form.errors[`bijboekers.${index}.achternaam`] !== undefined" class="stent-form-errors">
                    <li v-for="error in form.errors[`bijboekers.${index}.achternaam`]" :key="error" class="sgt-field-error">{{ error }}</li>
                  </ul>
                </div>
              </div>

              <div class="col-sm-6 col-md-4">
                <div class="input-container" :class="{'error': form.errors[`bijboekers.${index}.geboortedatum`] !== undefined}">
                  <label>Geboortedatum <span class="requirement">(verplicht)</span></label>
                  <input type="text" v-model="form.data.bijboekers[index].geboortedatum" class="sis-field-input form-control" placeholder="Formaat: dd-mm-yyyy" _required>

                  <ul v-if="form.errors[`bijboekers.${index}.geboortedatum`] !== undefined" class="stent-form-errors">
                    <li v-for="error in form.errors[`bijboekers.${index}.geboortedatum`]" :key="error" class="sis-field-error">{{ error }}</li>
                  </ul>
                </div>
              </div>

              <div class="col-sm-6 col-md-4">
                <div class="input-container" :class="{'error': form.errors[`bijboekers.${index}.telefoonnummer`] !== undefined}">
                  <label>Telefoonnummer <span class="requirement">(verplicht)</span></label>
                  <input type="text" v-model="form.data.bijboekers[index].telefoonnummer" class="sis-field-input form-control" _required>

                  <ul v-if="form.errors[`bijboekers.${index}.telefoonnummer`] !== undefined" class="stent-form-errors">
                    <li v-for="error in form.errors[`bijboekers.${index}.telefoonnummer`]" :key="error" class="sis-field-error">{{ error }}</li>
                  </ul>

                  <i class="btb bt-phone"></i>
                </div>
              </div>

              <div class="col-sm-6 col-md-4" v-if="show_provincie_veld">
                <div class="input-container selectbox">
                  <label>Provincie</label>

                  <select v-model="form.data.bijboekers[index].provincie" data-lpignore="true" required="required" class="sgt-field-input form-select">
                    <option value="" selected>Maak een keuze</option>
                    <option value="Drenthe">Drenthe</option>
                    <option value="Flevoland">Flevoland</option>
                    <option value="Friesland">Friesland</option>
                    <option value="Gelderland">Gelderland</option>
                    <option value="Groningen">Groningen</option>
                    <option value="Limburg">Limburg</option>
                    <option value="Noord-Brabant">Noord-Brabant</option>
                    <option value="Noord-Holland">Noord-Holland</option>
                    <option value="Overijssel">Overijssel</option>
                    <option value="Utrecht">Utrecht</option>
                    <option value="Zeeland">Zeeland</option>
                    <option value="Zuid-Holland">Zuid-Holland</option>
                  </select>

                  <ul v-if="form.errors[`bijboekers.${index}.provincie`] !== undefined" class="stent-form-errors">
                    <li v-for="error in form.errors[`bijboekers.${index}.provincie`]" :key="error" class="sgt-field-error">{{ error }}</li>
                  </ul>
                </div>
              </div>

              <div class="cell large-12 input-container">
                <button class="btn btn-primary d-block ms-auto" v-on:click.prevent="removeAdditionalBooker(index)">verwijderen</button>
              </div>

              <div class="col-12">
                <div class="separator-title-container">
                </div>
              </div>
            </div>
          </div>

          <div class="cell input-container">
            <button class="btn btn-primary d-block ms-auto" v-on:click.prevent="addAdditionalBooker()">Bijboeker toevoegen</button>
          </div>

          <div class="col-md-12">
            <div class="input-container checkbox">
              <div class="checkbox-container" :class="{'error': form.errors.akkoord_voorwaarden.length > 0}">
                  <input v-model="form.data.akkoord_voorwaarden" type="checkbox" name="voorwaarden" id="voorwaarden">
                  <label for="voorwaarden">
                    Ik ga akkoord en bevestig dat ik op de hoogte ben van de <a href="/algemene-voorwaarden" target="_blank">Algemene voorwaarden</a>
                    en de <a href="/privacy-policy" target="_blank">Privacy policy</a>.
                  </label>

                  <ul v-if="form.errors.akkoord_voorwaarden.length > 0" class="stent-form-errors">
                    <li v-for="error in form.errors.akkoord_voorwaarden" :key="error" class="sgt-field-error">{{ error }}</li>
                  </ul>
              </div>
            </div>
          </div>

          <div class="col-md-12">
            <div class="input-container checkbox">
              <div class="checkbox-container" :class="{'error': form.errors.akkoord_bijzondere_persoonsgegevens.length > 0}">
                  <input v-model="form.data.akkoord_bijzondere_persoonsgegevens" type="checkbox" name="akkoord_bijzondere_persoonsgegevens" id="akkoord_bijzondere_persoonsgegevens">
                  <label for="akkoord_bijzondere_persoonsgegevens">
                    Ja, ik geef toestemming voor het verwerken van door mij verstrekte en/of te verstrekken bijzondere persoonsgegevens ten behoeve van de castingprocedure van STENT Casting, zoals beschreven in het Privacy-en Cookiestatement.
                  </label>

                  <ul v-if="form.errors.akkoord_bijzondere_persoonsgegevens.length > 0" class="stent-form-errors">
                    <li v-for="error in form.errors.akkoord_bijzondere_persoonsgegevens" :key="error" class="sgt-field-error">{{ error }}</li>
                  </ul>
              </div>
            </div>
          </div>

          <div v-if="loading" class="col-12 input-container">
            <button class="btn btn-primary d-block ms-auto" type="submit" disabled>Aan het laden...</button>
          </div>
          <div v-else class="col-12 input-container">
            <button type="button" class="btn btn-primary d-block ms-auto" data-bs-toggle="modal" data-bs-target="#emailmodal">Verzenden</button>
          </div>
        </div>
        <EmailModal
          :email="this.form.data.email"
          @edit="editEmail"
          @send="sendSubmit"
        />
      </form>
    </div>

    <div v-if="done">
      <h1>Aanmelding voltooid</h1>

      <p>De aanmelding is gelukt.</p>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import helpers from './utils/helpers';
import EmailModal from './components/EmailModal.vue';

export default {
  components: {
    EmailModal,
  },
  data() {
    return {
      show_provincie_veld: (helpers.attribute('provincie_veld') === 'true'),

      form: {
        data: {
          voornaam: null,
          voorvoegsels: null,
          achternaam: null,
          email: null,
          geboortedatum: null,
          telefoonnummer: null,
          provincie: '',
          bijboekers: [],
          opdracht_id: helpers.attribute('opdracht_id'),
          akkoord_voorwaarden: '',
          akkoord_bijzondere_persoonsgegevens: '',
        },

        errors: {
          voornaam: [],
          voorvoegsels: [],
          achternaam: [],
          email: [],
          geboortedatum: [],
          telefoonnummer: [],
          provincie: [],
          bijboekers: [],
          opdracht_id: [],
          akkoord_voorwaarden: [],
          akkoord_bijzondere_persoonsgegevens: [],
        },

        response: {},
      },

      loading: false,
      done: false,
    };
  },

  methods: {
    sendSubmit: function () {
      this.loading = true;
      this.submit();
    },
    editEmail: function () {
      this.loading = false;

      helpers.scrollIntoView('.email-container', {
        block: 'center',
      });
    },
    addAdditionalBooker: function () {
      this.form.data.bijboekers.push({
        voornaam: null,
        voorvoegsels: null,
        achternaam: null,
        geboortedatum: null,
        telefoonnummer: null,
        provincie: '',
      });
    },

    removeAdditionalBooker: function (index) {
      this.form.data.bijboekers.splice(index, 1);
    },

    submit: function () {
      this.loading = true;

      axios.post(`${helpers.attribute('api_endpoint')}/api/dashboard/users/create_publiek_aanmelding`, this.form.data)
        .then((response) => {
          this.form.response = response.data;
          this.done = true;
          this.loading = false;

          helpers.scrollIntoView('#stent-gebruiker-toevoegen');
        })
        .catch((error) => {
          this.loading = false;

          this.form.errors = {
            ...helpers.setAllObjectPropertiesToArray(this.form.errors),
            ...error.response.data.errors,
          };
        });
    },
  },
};
</script>
